// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/rule.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Empty, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { DateRange, FieldError, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";

/**
 * RuleDomain selects the fact context a rule's condition evaluates against.
 *
 * @generated from enum tracker.v1.RuleDomain
 */
export enum RuleDomain {
  /**
   * @generated from enum value: RULE_DOMAIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * click RequestContext (routing)
   *
   * @generated from enum value: RULE_DOMAIN_CLICK = 1;
   */
  CLICK = 1,

  /**
   * metrics window (alerting)
   *
   * @generated from enum value: RULE_DOMAIN_METRICS = 2;
   */
  METRICS = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(RuleDomain)
proto3.util.setEnumType(RuleDomain, "tracker.v1.RuleDomain", [
  { no: 0, name: "RULE_DOMAIN_UNSPECIFIED" },
  { no: 1, name: "RULE_DOMAIN_CLICK" },
  { no: 2, name: "RULE_DOMAIN_METRICS" },
]);

/**
 * @generated from enum tracker.v1.CompareOp
 */
export enum CompareOp {
  /**
   * @generated from enum value: COMPARE_OP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMPARE_OP_EQ = 1;
   */
  EQ = 1,

  /**
   * @generated from enum value: COMPARE_OP_LT = 2;
   */
  LT = 2,

  /**
   * @generated from enum value: COMPARE_OP_LTE = 3;
   */
  LTE = 3,

  /**
   * @generated from enum value: COMPARE_OP_GT = 4;
   */
  GT = 4,

  /**
   * @generated from enum value: COMPARE_OP_GTE = 5;
   */
  GTE = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(CompareOp)
proto3.util.setEnumType(CompareOp, "tracker.v1.CompareOp", [
  { no: 0, name: "COMPARE_OP_UNSPECIFIED" },
  { no: 1, name: "COMPARE_OP_EQ" },
  { no: 2, name: "COMPARE_OP_LT" },
  { no: 3, name: "COMPARE_OP_LTE" },
  { no: 4, name: "COMPARE_OP_GT" },
  { no: 5, name: "COMPARE_OP_GTE" },
]);

/**
 * @generated from enum tracker.v1.BotSignal
 */
export enum BotSignal {
  /**
   * @generated from enum value: BOT_SIGNAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOT_SIGNAL_IS_BOT = 1;
   */
  IS_BOT = 1,

  /**
   * @generated from enum value: BOT_SIGNAL_IS_DATACENTER = 2;
   */
  IS_DATACENTER = 2,

  /**
   * @generated from enum value: BOT_SIGNAL_IS_TOR = 3;
   */
  IS_TOR = 3,

  /**
   * @generated from enum value: BOT_SIGNAL_IS_VPN = 4;
   */
  IS_VPN = 4,

  /**
   * @generated from enum value: BOT_SIGNAL_UA_ANOMALY = 5;
   */
  UA_ANOMALY = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(BotSignal)
proto3.util.setEnumType(BotSignal, "tracker.v1.BotSignal", [
  { no: 0, name: "BOT_SIGNAL_UNSPECIFIED" },
  { no: 1, name: "BOT_SIGNAL_IS_BOT" },
  { no: 2, name: "BOT_SIGNAL_IS_DATACENTER" },
  { no: 3, name: "BOT_SIGNAL_IS_TOR" },
  { no: 4, name: "BOT_SIGNAL_IS_VPN" },
  { no: 5, name: "BOT_SIGNAL_UA_ANOMALY" },
]);

/**
 * @generated from enum tracker.v1.Severity
 */
export enum Severity {
  /**
   * @generated from enum value: SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEVERITY_INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: SEVERITY_WARNING = 2;
   */
  WARNING = 2,

  /**
   * @generated from enum value: SEVERITY_CRITICAL = 3;
   */
  CRITICAL = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(Severity)
proto3.util.setEnumType(Severity, "tracker.v1.Severity", [
  { no: 0, name: "SEVERITY_UNSPECIFIED" },
  { no: 1, name: "SEVERITY_INFO" },
  { no: 2, name: "SEVERITY_WARNING" },
  { no: 3, name: "SEVERITY_CRITICAL" },
]);

/**
 * Condition is the sealed predicate node. Exactly one oneof case is set. The
 * case name is the condition kind; the persisted/worker JSON is internally
 * tagged on a "kind" string and stays flat-keyed (see internal/domain/rule.go).
 *
 * @generated from message tracker.v1.Condition
 */
export class Condition extends Message<Condition> {
  /**
   * @generated from oneof tracker.v1.Condition.kind
   */
  kind: {
    /**
     * Logical
     *
     * @generated from field: tracker.v1.ConditionGroup group_and = 1;
     */
    value: ConditionGroup;
    case: "groupAnd";
  } | {
    /**
     * @generated from field: tracker.v1.ConditionGroup group_or = 2;
     */
    value: ConditionGroup;
    case: "groupOr";
  } | {
    /**
     * @generated from field: tracker.v1.Condition not = 3;
     */
    value: Condition;
    case: "not";
  } | {
    /**
     * @generated from field: google.protobuf.Empty all = 4;
     */
    value: Empty;
    case: "all";
  } | {
    /**
     * Request-domain leaves (CLICK)
     *
     * ISO country codes
     *
     * @generated from field: tracker.v1.StringList country = 10;
     */
    value: StringList;
    case: "country";
  } | {
    /**
     * language tags
     *
     * @generated from field: tracker.v1.StringList language = 11;
     */
    value: StringList;
    case: "language";
  } | {
    /**
     * mobile/tablet/desktop
     *
     * @generated from field: tracker.v1.StringList device = 12;
     */
    value: StringList;
    case: "device";
  } | {
    /**
     * @generated from field: tracker.v1.KeyValue url_param = 15;
     */
    value: KeyValue;
    case: "urlParam";
  } | {
    /**
     * @generated from field: tracker.v1.KeyValue header = 16;
     */
    value: KeyValue;
    case: "header";
  } | {
    /**
     * @generated from field: tracker.v1.ScoreCondition bot_score = 18;
     */
    value: ScoreCondition;
    case: "botScore";
  } | {
    /**
     * @generated from field: tracker.v1.TimeOfDayCondition time_of_day = 19;
     */
    value: TimeOfDayCondition;
    case: "timeOfDay";
  } | {
    /**
     * @generated from field: tracker.v1.WeightCondition weight_split = 20;
     */
    value: WeightCondition;
    case: "weightSplit";
  } | {
    /**
     * @generated from field: tracker.v1.ExpressionCondition expression = 21;
     */
    value: ExpressionCondition;
    case: "expression";
  } | {
    /**
     * @generated from field: tracker.v1.BotSignalCondition bot_signal = 22;
     */
    value: BotSignalCondition;
    case: "botSignal";
  } | {
    /**
     * A field of the visit (region, city, isp, asn, os, browser, ip,
     * user_agent, referrer, …) under in / not_in / contains / not_contains /
     * regex / not_regex — internal/domain/match.go.
     *
     * @generated from field: tracker.v1.FieldMatch match = 23;
     */
    value: FieldMatch;
    case: "match";
  } | {
    /**
     * Metrics-domain leaves (METRICS)
     *
     * @generated from field: tracker.v1.MetricCondition spend_spike = 30;
     */
    value: MetricCondition;
    case: "spendSpike";
  } | {
    /**
     * @generated from field: tracker.v1.MetricCondition conversion_drop = 31;
     */
    value: MetricCondition;
    case: "conversionDrop";
  } | {
    /**
     * @generated from field: tracker.v1.MetricCondition roi_below = 32;
     */
    value: MetricCondition;
    case: "roiBelow";
  } | {
    /**
     * @generated from field: tracker.v1.MetricCondition zero_conversions = 33;
     */
    value: MetricCondition;
    case: "zeroConversions";
  } | {
    /**
     * @generated from field: tracker.v1.MetricCondition cpa_above = 34;
     */
    value: MetricCondition;
    case: "cpaAbove";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Condition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Condition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_and", kind: "message", T: ConditionGroup, oneof: "kind" },
    { no: 2, name: "group_or", kind: "message", T: ConditionGroup, oneof: "kind" },
    { no: 3, name: "not", kind: "message", T: Condition, oneof: "kind" },
    { no: 4, name: "all", kind: "message", T: Empty, oneof: "kind" },
    { no: 10, name: "country", kind: "message", T: StringList, oneof: "kind" },
    { no: 11, name: "language", kind: "message", T: StringList, oneof: "kind" },
    { no: 12, name: "device", kind: "message", T: StringList, oneof: "kind" },
    { no: 15, name: "url_param", kind: "message", T: KeyValue, oneof: "kind" },
    { no: 16, name: "header", kind: "message", T: KeyValue, oneof: "kind" },
    { no: 18, name: "bot_score", kind: "message", T: ScoreCondition, oneof: "kind" },
    { no: 19, name: "time_of_day", kind: "message", T: TimeOfDayCondition, oneof: "kind" },
    { no: 20, name: "weight_split", kind: "message", T: WeightCondition, oneof: "kind" },
    { no: 21, name: "expression", kind: "message", T: ExpressionCondition, oneof: "kind" },
    { no: 22, name: "bot_signal", kind: "message", T: BotSignalCondition, oneof: "kind" },
    { no: 23, name: "match", kind: "message", T: FieldMatch, oneof: "kind" },
    { no: 30, name: "spend_spike", kind: "message", T: MetricCondition, oneof: "kind" },
    { no: 31, name: "conversion_drop", kind: "message", T: MetricCondition, oneof: "kind" },
    { no: 32, name: "roi_below", kind: "message", T: MetricCondition, oneof: "kind" },
    { no: 33, name: "zero_conversions", kind: "message", T: MetricCondition, oneof: "kind" },
    { no: 34, name: "cpa_above", kind: "message", T: MetricCondition, oneof: "kind" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Condition {
    return new Condition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Condition {
    return new Condition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Condition {
    return new Condition().fromJsonString(jsonString, options);
  }

  static equals(a: Condition | PlainMessage<Condition> | undefined, b: Condition | PlainMessage<Condition> | undefined): boolean {
    return proto3.util.equals(Condition, a, b);
  }
}

/**
 * @generated from message tracker.v1.ConditionGroup
 */
export class ConditionGroup extends Message<ConditionGroup> {
  /**
   * @generated from field: repeated tracker.v1.Condition children = 1;
   */
  children: Condition[] = [];

  constructor(data?: PartialMessage<ConditionGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ConditionGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "children", kind: "message", T: Condition, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConditionGroup {
    return new ConditionGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConditionGroup {
    return new ConditionGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConditionGroup {
    return new ConditionGroup().fromJsonString(jsonString, options);
  }

  static equals(a: ConditionGroup | PlainMessage<ConditionGroup> | undefined, b: ConditionGroup | PlainMessage<ConditionGroup> | undefined): boolean {
    return proto3.util.equals(ConditionGroup, a, b);
  }
}

/**
 * @generated from message tracker.v1.StringList
 */
export class StringList extends Message<StringList> {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[] = [];

  constructor(data?: PartialMessage<StringList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.StringList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StringList {
    return new StringList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StringList {
    return new StringList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StringList {
    return new StringList().fromJsonString(jsonString, options);
  }

  static equals(a: StringList | PlainMessage<StringList> | undefined, b: StringList | PlainMessage<StringList> | undefined): boolean {
    return proto3.util.equals(StringList, a, b);
  }
}

/**
 * One field condition: field (country, region, city, isp, asn, os, browser,
 * device_type, language, ip, user_agent, referrer, param:<name>), op and
 * values. Case-insensitive; ip in takes addresses and CIDR ranges; a regex is
 * the bounded subset domain.SafePattern accepts; present / not_present take no
 * values (a param named with an empty value is present).
 *
 * @generated from message tracker.v1.FieldMatch
 */
export class FieldMatch extends Message<FieldMatch> {
  /**
   * @generated from field: string field = 1;
   */
  field = "";

  /**
   * @generated from field: string op = 2;
   */
  op = "";

  /**
   * @generated from field: repeated string values = 3;
   */
  values: string[] = [];

  constructor(data?: PartialMessage<FieldMatch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FieldMatch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "op", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FieldMatch {
    return new FieldMatch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FieldMatch {
    return new FieldMatch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FieldMatch {
    return new FieldMatch().fromJsonString(jsonString, options);
  }

  static equals(a: FieldMatch | PlainMessage<FieldMatch> | undefined, b: FieldMatch | PlainMessage<FieldMatch> | undefined): boolean {
    return proto3.util.equals(FieldMatch, a, b);
  }
}

/**
 * @generated from message tracker.v1.KeyValue
 */
export class KeyValue extends Message<KeyValue> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<KeyValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.KeyValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KeyValue {
    return new KeyValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KeyValue {
    return new KeyValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KeyValue {
    return new KeyValue().fromJsonString(jsonString, options);
  }

  static equals(a: KeyValue | PlainMessage<KeyValue> | undefined, b: KeyValue | PlainMessage<KeyValue> | undefined): boolean {
    return proto3.util.equals(KeyValue, a, b);
  }
}

/**
 * @generated from message tracker.v1.ScoreCondition
 */
export class ScoreCondition extends Message<ScoreCondition> {
  /**
   * @generated from field: tracker.v1.CompareOp op = 1;
   */
  op = CompareOp.UNSPECIFIED;

  /**
   * @generated from field: int32 threshold = 2;
   */
  threshold = 0;

  constructor(data?: PartialMessage<ScoreCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ScoreCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "op", kind: "enum", T: proto3.getEnumType(CompareOp) },
    { no: 2, name: "threshold", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScoreCondition {
    return new ScoreCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScoreCondition {
    return new ScoreCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScoreCondition {
    return new ScoreCondition().fromJsonString(jsonString, options);
  }

  static equals(a: ScoreCondition | PlainMessage<ScoreCondition> | undefined, b: ScoreCondition | PlainMessage<ScoreCondition> | undefined): boolean {
    return proto3.util.equals(ScoreCondition, a, b);
  }
}

/**
 * @generated from message tracker.v1.TimeOfDayCondition
 */
export class TimeOfDayCondition extends Message<TimeOfDayCondition> {
  /**
   * 0-24, in tz (UTC when tz is empty)
   *
   * @generated from field: int32 hour_start = 1;
   */
  hourStart = 0;

  /**
   * @generated from field: int32 hour_end = 2;
   */
  hourEnd = 0;

  /**
   * IANA zone the hours are counted in ("" = UTC). A campaign's buyer
   * schedule (CampaignRule SCHEDULE) carries the workspace's zone.
   *
   * @generated from field: string tz = 3;
   */
  tz = "";

  /**
   * Local days the window holds on, 1 = Monday … 7 = Sunday; empty = every day.
   *
   * @generated from field: repeated int32 weekdays = 4;
   */
  weekdays: number[] = [];

  constructor(data?: PartialMessage<TimeOfDayCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TimeOfDayCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hour_start", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "hour_end", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "tz", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "weekdays", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeOfDayCondition {
    return new TimeOfDayCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeOfDayCondition {
    return new TimeOfDayCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeOfDayCondition {
    return new TimeOfDayCondition().fromJsonString(jsonString, options);
  }

  static equals(a: TimeOfDayCondition | PlainMessage<TimeOfDayCondition> | undefined, b: TimeOfDayCondition | PlainMessage<TimeOfDayCondition> | undefined): boolean {
    return proto3.util.equals(TimeOfDayCondition, a, b);
  }
}

/**
 * @generated from message tracker.v1.WeightCondition
 */
export class WeightCondition extends Message<WeightCondition> {
  /**
   * 0-100
   *
   * @generated from field: int32 weight = 1;
   */
  weight = 0;

  constructor(data?: PartialMessage<WeightCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.WeightCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "weight", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WeightCondition {
    return new WeightCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WeightCondition {
    return new WeightCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WeightCondition {
    return new WeightCondition().fromJsonString(jsonString, options);
  }

  static equals(a: WeightCondition | PlainMessage<WeightCondition> | undefined, b: WeightCondition | PlainMessage<WeightCondition> | undefined): boolean {
    return proto3.util.equals(WeightCondition, a, b);
  }
}

/**
 * @generated from message tracker.v1.ExpressionCondition
 */
export class ExpressionCondition extends Message<ExpressionCondition> {
  /**
   * expr-lang
   *
   * @generated from field: string source = 1;
   */
  source = "";

  constructor(data?: PartialMessage<ExpressionCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ExpressionCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExpressionCondition {
    return new ExpressionCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExpressionCondition {
    return new ExpressionCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExpressionCondition {
    return new ExpressionCondition().fromJsonString(jsonString, options);
  }

  static equals(a: ExpressionCondition | PlainMessage<ExpressionCondition> | undefined, b: ExpressionCondition | PlainMessage<ExpressionCondition> | undefined): boolean {
    return proto3.util.equals(ExpressionCondition, a, b);
  }
}

/**
 * @generated from message tracker.v1.BotSignalCondition
 */
export class BotSignalCondition extends Message<BotSignalCondition> {
  /**
   * @generated from field: tracker.v1.BotSignal signal = 1;
   */
  signal = BotSignal.UNSPECIFIED;

  constructor(data?: PartialMessage<BotSignalCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BotSignalCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "signal", kind: "enum", T: proto3.getEnumType(BotSignal) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BotSignalCondition {
    return new BotSignalCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BotSignalCondition {
    return new BotSignalCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BotSignalCondition {
    return new BotSignalCondition().fromJsonString(jsonString, options);
  }

  static equals(a: BotSignalCondition | PlainMessage<BotSignalCondition> | undefined, b: BotSignalCondition | PlainMessage<BotSignalCondition> | undefined): boolean {
    return proto3.util.equals(BotSignalCondition, a, b);
  }
}

/**
 * @generated from message tracker.v1.MetricCondition
 */
export class MetricCondition extends Message<MetricCondition> {
  /**
   * Threshold semantics depend on the leaf kind (ratio for roi_below, amount
   * for cpa_above, percentage for spend_spike/conversion_drop).
   *
   * @generated from field: string threshold = 1;
   */
  threshold = "";

  /**
   * @generated from field: int32 window_minutes = 2;
   */
  windowMinutes = 0;

  /**
   * @generated from field: string comparison_period = 3;
   */
  comparisonPeriod = "";

  constructor(data?: PartialMessage<MetricCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.MetricCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threshold", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "window_minutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "comparison_period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricCondition {
    return new MetricCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricCondition {
    return new MetricCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricCondition {
    return new MetricCondition().fromJsonString(jsonString, options);
  }

  static equals(a: MetricCondition | PlainMessage<MetricCondition> | undefined, b: MetricCondition | PlainMessage<MetricCondition> | undefined): boolean {
    return proto3.util.equals(MetricCondition, a, b);
  }
}

/**
 * @generated from message tracker.v1.Action
 */
export class Action extends Message<Action> {
  /**
   * @generated from oneof tracker.v1.Action.kind
   */
  kind: {
    /**
     * @generated from field: tracker.v1.RouteAction route = 1;
     */
    value: RouteAction;
    case: "route";
  } | {
    /**
     * @generated from field: tracker.v1.BlockAction block = 2;
     */
    value: BlockAction;
    case: "block";
  } | {
    /**
     * @generated from field: tracker.v1.NotifyAction notify = 3;
     */
    value: NotifyAction;
    case: "notify";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Action>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Action";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "route", kind: "message", T: RouteAction, oneof: "kind" },
    { no: 2, name: "block", kind: "message", T: BlockAction, oneof: "kind" },
    { no: 3, name: "notify", kind: "message", T: NotifyAction, oneof: "kind" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Action {
    return new Action().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Action {
    return new Action().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Action {
    return new Action().fromJsonString(jsonString, options);
  }

  static equals(a: Action | PlainMessage<Action> | undefined, b: Action | PlainMessage<Action> | undefined): boolean {
    return proto3.util.equals(Action, a, b);
  }
}

/**
 * @generated from message tracker.v1.RouteAction
 */
export class RouteAction extends Message<RouteAction> {
  /**
   * @generated from field: optional string offer_id = 1;
   */
  offerId?: string;

  /**
   * @generated from field: optional string lander_id = 2;
   */
  landerId?: string;

  constructor(data?: PartialMessage<RouteAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RouteAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RouteAction {
    return new RouteAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RouteAction {
    return new RouteAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RouteAction {
    return new RouteAction().fromJsonString(jsonString, options);
  }

  static equals(a: RouteAction | PlainMessage<RouteAction> | undefined, b: RouteAction | PlainMessage<RouteAction> | undefined): boolean {
    return proto3.util.equals(RouteAction, a, b);
  }
}

/**
 * @generated from message tracker.v1.BlockAction
 */
export class BlockAction extends Message<BlockAction> {
  /**
   * @generated from field: string reason = 1;
   */
  reason = "";

  constructor(data?: PartialMessage<BlockAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BlockAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockAction {
    return new BlockAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockAction {
    return new BlockAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockAction {
    return new BlockAction().fromJsonString(jsonString, options);
  }

  static equals(a: BlockAction | PlainMessage<BlockAction> | undefined, b: BlockAction | PlainMessage<BlockAction> | undefined): boolean {
    return proto3.util.equals(BlockAction, a, b);
  }
}

/**
 * NotifyAction: a fired METRICS rule becomes the hub event
 * tracker.rule.triggered for the rule's org. destination_ids are hub
 * destinations of that org (GET /api/org/destinations) the rule sends to,
 * besides the org's own hub rules and the owner's personal channels.
 * The tracker's own MATTERMOST/EMAIL channels (field 1, enum
 * NotifyChannelType, message NotifyChannel) are gone.
 *
 * @generated from message tracker.v1.NotifyAction
 */
export class NotifyAction extends Message<NotifyAction> {
  /**
   * @generated from field: tracker.v1.Severity severity = 2;
   */
  severity = Severity.UNSPECIFIED;

  /**
   * @generated from field: repeated string destination_ids = 3;
   */
  destinationIds: string[] = [];

  constructor(data?: PartialMessage<NotifyAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.NotifyAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "severity", kind: "enum", T: proto3.getEnumType(Severity) },
    { no: 3, name: "destination_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotifyAction {
    return new NotifyAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotifyAction {
    return new NotifyAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotifyAction {
    return new NotifyAction().fromJsonString(jsonString, options);
  }

  static equals(a: NotifyAction | PlainMessage<NotifyAction> | undefined, b: NotifyAction | PlainMessage<NotifyAction> | undefined): boolean {
    return proto3.util.equals(NotifyAction, a, b);
  }
}

/**
 * @generated from message tracker.v1.Rule
 */
export class Rule extends Message<Rule> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: tracker.v1.RuleDomain domain = 5;
   */
  domain = RuleDomain.UNSPECIFIED;

  /**
   * campaign_id optionally scopes a METRICS rule to one campaign (nil =
   * workspace-wide). Unused by CLICK rules.
   *
   * @generated from field: optional string campaign_id = 15;
   */
  campaignId?: string;

  /**
   * @generated from field: tracker.v1.Condition condition = 6;
   */
  condition?: Condition;

  /**
   * @generated from field: repeated tracker.v1.Action actions = 7;
   */
  actions: Action[] = [];

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled = false;

  /**
   * @generated from field: int32 version = 9;
   */
  version = 0;

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 10;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 11;
   */
  ownership?: Ownership;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_triggered = 12;
   */
  lastTriggered?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<Rule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Rule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "domain", kind: "enum", T: proto3.getEnumType(RuleDomain) },
    { no: 15, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "condition", kind: "message", T: Condition },
    { no: 7, name: "actions", kind: "message", T: Action, repeated: true },
    { no: 8, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 11, name: "ownership", kind: "message", T: Ownership },
    { no: 12, name: "last_triggered", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
    { no: 14, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Rule {
    return new Rule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Rule {
    return new Rule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Rule {
    return new Rule().fromJsonString(jsonString, options);
  }

  static equals(a: Rule | PlainMessage<Rule> | undefined, b: Rule | PlainMessage<Rule> | undefined): boolean {
    return proto3.util.equals(Rule, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListRulesFilter
 */
export class ListRulesFilter extends Message<ListRulesFilter> {
  /**
   * @generated from field: optional tracker.v1.RuleDomain domain = 1;
   */
  domain?: RuleDomain;

  /**
   * @generated from field: optional bool enabled = 2;
   */
  enabled?: boolean;

  /**
   * @generated from field: optional string search = 3;
   */
  search?: string;

  constructor(data?: PartialMessage<ListRulesFilter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListRulesFilter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "enum", T: proto3.getEnumType(RuleDomain), opt: true },
    { no: 2, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRulesFilter {
    return new ListRulesFilter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRulesFilter {
    return new ListRulesFilter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRulesFilter {
    return new ListRulesFilter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRulesFilter | PlainMessage<ListRulesFilter> | undefined, b: ListRulesFilter | PlainMessage<ListRulesFilter> | undefined): boolean {
    return proto3.util.equals(ListRulesFilter, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListRulesRequest
 */
export class ListRulesRequest extends Message<ListRulesRequest> {
  /**
   * @generated from field: tracker.v1.ListRulesFilter filter = 1;
   */
  filter?: ListRulesFilter;

  /**
   * @generated from field: tracker.v1.Pagination pagination = 2;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListRulesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListRulesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filter", kind: "message", T: ListRulesFilter },
    { no: 2, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRulesRequest {
    return new ListRulesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRulesRequest {
    return new ListRulesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRulesRequest {
    return new ListRulesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRulesRequest | PlainMessage<ListRulesRequest> | undefined, b: ListRulesRequest | PlainMessage<ListRulesRequest> | undefined): boolean {
    return proto3.util.equals(ListRulesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListRulesResponse
 */
export class ListRulesResponse extends Message<ListRulesResponse> {
  /**
   * @generated from field: repeated tracker.v1.Rule items = 1;
   */
  items: Rule[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListRulesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListRulesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: Rule, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRulesResponse {
    return new ListRulesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRulesResponse {
    return new ListRulesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRulesResponse {
    return new ListRulesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRulesResponse | PlainMessage<ListRulesResponse> | undefined, b: ListRulesResponse | PlainMessage<ListRulesResponse> | undefined): boolean {
    return proto3.util.equals(ListRulesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetRuleRequest
 */
export class GetRuleRequest extends Message<GetRuleRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetRuleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetRuleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRuleRequest {
    return new GetRuleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRuleRequest {
    return new GetRuleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRuleRequest {
    return new GetRuleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRuleRequest | PlainMessage<GetRuleRequest> | undefined, b: GetRuleRequest | PlainMessage<GetRuleRequest> | undefined): boolean {
    return proto3.util.equals(GetRuleRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetRuleResponse
 */
export class GetRuleResponse extends Message<GetRuleResponse> {
  /**
   * @generated from field: tracker.v1.Rule rule = 1;
   */
  rule?: Rule;

  /**
   * referenced_by lists flow ids that reference this rule (drives the "Used in
   * N" badge and blocks deletion while non-empty).
   *
   * @generated from field: repeated string referenced_by = 2;
   */
  referencedBy: string[] = [];

  constructor(data?: PartialMessage<GetRuleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetRuleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule", kind: "message", T: Rule },
    { no: 2, name: "referenced_by", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRuleResponse {
    return new GetRuleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRuleResponse {
    return new GetRuleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRuleResponse {
    return new GetRuleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRuleResponse | PlainMessage<GetRuleResponse> | undefined, b: GetRuleResponse | PlainMessage<GetRuleResponse> | undefined): boolean {
    return proto3.util.equals(GetRuleResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateRuleRequest
 */
export class CreateRuleRequest extends Message<CreateRuleRequest> {
  /**
   * @generated from field: tracker.v1.Rule rule = 1;
   */
  rule?: Rule;

  constructor(data?: PartialMessage<CreateRuleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateRuleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule", kind: "message", T: Rule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRuleRequest {
    return new CreateRuleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRuleRequest {
    return new CreateRuleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRuleRequest {
    return new CreateRuleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRuleRequest | PlainMessage<CreateRuleRequest> | undefined, b: CreateRuleRequest | PlainMessage<CreateRuleRequest> | undefined): boolean {
    return proto3.util.equals(CreateRuleRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateRuleResponse
 */
export class CreateRuleResponse extends Message<CreateRuleResponse> {
  /**
   * @generated from field: tracker.v1.Rule rule = 1;
   */
  rule?: Rule;

  constructor(data?: PartialMessage<CreateRuleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateRuleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule", kind: "message", T: Rule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRuleResponse {
    return new CreateRuleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRuleResponse {
    return new CreateRuleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRuleResponse {
    return new CreateRuleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRuleResponse | PlainMessage<CreateRuleResponse> | undefined, b: CreateRuleResponse | PlainMessage<CreateRuleResponse> | undefined): boolean {
    return proto3.util.equals(CreateRuleResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateRuleRequest
 */
export class UpdateRuleRequest extends Message<UpdateRuleRequest> {
  /**
   * @generated from field: tracker.v1.Rule rule = 1;
   */
  rule?: Rule;

  constructor(data?: PartialMessage<UpdateRuleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateRuleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule", kind: "message", T: Rule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRuleRequest {
    return new UpdateRuleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRuleRequest {
    return new UpdateRuleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRuleRequest {
    return new UpdateRuleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRuleRequest | PlainMessage<UpdateRuleRequest> | undefined, b: UpdateRuleRequest | PlainMessage<UpdateRuleRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRuleRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateRuleResponse
 */
export class UpdateRuleResponse extends Message<UpdateRuleResponse> {
  /**
   * @generated from field: tracker.v1.Rule rule = 1;
   */
  rule?: Rule;

  constructor(data?: PartialMessage<UpdateRuleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateRuleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule", kind: "message", T: Rule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRuleResponse {
    return new UpdateRuleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRuleResponse {
    return new UpdateRuleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRuleResponse {
    return new UpdateRuleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRuleResponse | PlainMessage<UpdateRuleResponse> | undefined, b: UpdateRuleResponse | PlainMessage<UpdateRuleResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRuleResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteRuleRequest
 */
export class DeleteRuleRequest extends Message<DeleteRuleRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteRuleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteRuleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRuleRequest {
    return new DeleteRuleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRuleRequest {
    return new DeleteRuleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRuleRequest {
    return new DeleteRuleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRuleRequest | PlainMessage<DeleteRuleRequest> | undefined, b: DeleteRuleRequest | PlainMessage<DeleteRuleRequest> | undefined): boolean {
    return proto3.util.equals(DeleteRuleRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteRuleResponse
 */
export class DeleteRuleResponse extends Message<DeleteRuleResponse> {
  constructor(data?: PartialMessage<DeleteRuleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteRuleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRuleResponse {
    return new DeleteRuleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRuleResponse {
    return new DeleteRuleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRuleResponse {
    return new DeleteRuleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRuleResponse | PlainMessage<DeleteRuleResponse> | undefined, b: DeleteRuleResponse | PlainMessage<DeleteRuleResponse> | undefined): boolean {
    return proto3.util.equals(DeleteRuleResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ValidateRuleRequest
 */
export class ValidateRuleRequest extends Message<ValidateRuleRequest> {
  /**
   * @generated from field: tracker.v1.Rule rule = 1;
   */
  rule?: Rule;

  constructor(data?: PartialMessage<ValidateRuleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateRuleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule", kind: "message", T: Rule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateRuleRequest {
    return new ValidateRuleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateRuleRequest {
    return new ValidateRuleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateRuleRequest {
    return new ValidateRuleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateRuleRequest | PlainMessage<ValidateRuleRequest> | undefined, b: ValidateRuleRequest | PlainMessage<ValidateRuleRequest> | undefined): boolean {
    return proto3.util.equals(ValidateRuleRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ValidateRuleResponse
 */
export class ValidateRuleResponse extends Message<ValidateRuleResponse> {
  /**
   * @generated from field: repeated tracker.v1.FieldError errors = 1;
   */
  errors: FieldError[] = [];

  constructor(data?: PartialMessage<ValidateRuleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateRuleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateRuleResponse {
    return new ValidateRuleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateRuleResponse {
    return new ValidateRuleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateRuleResponse {
    return new ValidateRuleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateRuleResponse | PlainMessage<ValidateRuleResponse> | undefined, b: ValidateRuleResponse | PlainMessage<ValidateRuleResponse> | undefined): boolean {
    return proto3.util.equals(ValidateRuleResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.RuleEvent
 */
export class RuleEvent extends Message<RuleEvent> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string rule_id = 2;
   */
  ruleId = "";

  /**
   * @generated from field: optional string campaign_id = 3;
   */
  campaignId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp triggered_at = 4;
   */
  triggeredAt?: Timestamp;

  /**
   * @generated from field: tracker.v1.Severity severity = 5;
   */
  severity = Severity.UNSPECIFIED;

  /**
   * @generated from field: string payload_json = 6;
   */
  payloadJson = "";

  /**
   * @generated from field: bool acknowledged = 7;
   */
  acknowledged = false;

  /**
   * @generated from field: optional google.protobuf.Timestamp acknowledged_at = 8;
   */
  acknowledgedAt?: Timestamp;

  /**
   * @generated from field: optional string acknowledged_by = 9;
   */
  acknowledgedBy?: string;

  constructor(data?: PartialMessage<RuleEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RuleEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "triggered_at", kind: "message", T: Timestamp },
    { no: 5, name: "severity", kind: "enum", T: proto3.getEnumType(Severity) },
    { no: 6, name: "payload_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "acknowledged", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "acknowledged_at", kind: "message", T: Timestamp, opt: true },
    { no: 9, name: "acknowledged_by", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RuleEvent {
    return new RuleEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RuleEvent {
    return new RuleEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RuleEvent {
    return new RuleEvent().fromJsonString(jsonString, options);
  }

  static equals(a: RuleEvent | PlainMessage<RuleEvent> | undefined, b: RuleEvent | PlainMessage<RuleEvent> | undefined): boolean {
    return proto3.util.equals(RuleEvent, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListRuleEventsFilter
 */
export class ListRuleEventsFilter extends Message<ListRuleEventsFilter> {
  /**
   * @generated from field: optional string rule_id = 1;
   */
  ruleId?: string;

  /**
   * @generated from field: optional tracker.v1.Severity severity = 2;
   */
  severity?: Severity;

  /**
   * @generated from field: optional bool unacknowledged_only = 3;
   */
  unacknowledgedOnly?: boolean;

  /**
   * @generated from field: optional tracker.v1.DateRange triggered_range = 4;
   */
  triggeredRange?: DateRange;

  constructor(data?: PartialMessage<ListRuleEventsFilter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListRuleEventsFilter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "severity", kind: "enum", T: proto3.getEnumType(Severity), opt: true },
    { no: 3, name: "unacknowledged_only", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "triggered_range", kind: "message", T: DateRange, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRuleEventsFilter {
    return new ListRuleEventsFilter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRuleEventsFilter {
    return new ListRuleEventsFilter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRuleEventsFilter {
    return new ListRuleEventsFilter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRuleEventsFilter | PlainMessage<ListRuleEventsFilter> | undefined, b: ListRuleEventsFilter | PlainMessage<ListRuleEventsFilter> | undefined): boolean {
    return proto3.util.equals(ListRuleEventsFilter, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListRuleEventsRequest
 */
export class ListRuleEventsRequest extends Message<ListRuleEventsRequest> {
  /**
   * @generated from field: tracker.v1.ListRuleEventsFilter filter = 1;
   */
  filter?: ListRuleEventsFilter;

  /**
   * @generated from field: tracker.v1.Pagination pagination = 2;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListRuleEventsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListRuleEventsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filter", kind: "message", T: ListRuleEventsFilter },
    { no: 2, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRuleEventsRequest {
    return new ListRuleEventsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRuleEventsRequest {
    return new ListRuleEventsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRuleEventsRequest {
    return new ListRuleEventsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRuleEventsRequest | PlainMessage<ListRuleEventsRequest> | undefined, b: ListRuleEventsRequest | PlainMessage<ListRuleEventsRequest> | undefined): boolean {
    return proto3.util.equals(ListRuleEventsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListRuleEventsResponse
 */
export class ListRuleEventsResponse extends Message<ListRuleEventsResponse> {
  /**
   * @generated from field: repeated tracker.v1.RuleEvent events = 1;
   */
  events: RuleEvent[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListRuleEventsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListRuleEventsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: RuleEvent, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRuleEventsResponse {
    return new ListRuleEventsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRuleEventsResponse {
    return new ListRuleEventsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRuleEventsResponse {
    return new ListRuleEventsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRuleEventsResponse | PlainMessage<ListRuleEventsResponse> | undefined, b: ListRuleEventsResponse | PlainMessage<ListRuleEventsResponse> | undefined): boolean {
    return proto3.util.equals(ListRuleEventsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.AcknowledgeRuleEventRequest
 */
export class AcknowledgeRuleEventRequest extends Message<AcknowledgeRuleEventRequest> {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId = "";

  /**
   * @generated from field: optional string acknowledged_by = 2;
   */
  acknowledgedBy?: string;

  constructor(data?: PartialMessage<AcknowledgeRuleEventRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AcknowledgeRuleEventRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "acknowledged_by", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcknowledgeRuleEventRequest {
    return new AcknowledgeRuleEventRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcknowledgeRuleEventRequest {
    return new AcknowledgeRuleEventRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcknowledgeRuleEventRequest {
    return new AcknowledgeRuleEventRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AcknowledgeRuleEventRequest | PlainMessage<AcknowledgeRuleEventRequest> | undefined, b: AcknowledgeRuleEventRequest | PlainMessage<AcknowledgeRuleEventRequest> | undefined): boolean {
    return proto3.util.equals(AcknowledgeRuleEventRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.AcknowledgeRuleEventResponse
 */
export class AcknowledgeRuleEventResponse extends Message<AcknowledgeRuleEventResponse> {
  /**
   * @generated from field: tracker.v1.RuleEvent event = 1;
   */
  event?: RuleEvent;

  constructor(data?: PartialMessage<AcknowledgeRuleEventResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.AcknowledgeRuleEventResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "message", T: RuleEvent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcknowledgeRuleEventResponse {
    return new AcknowledgeRuleEventResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcknowledgeRuleEventResponse {
    return new AcknowledgeRuleEventResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcknowledgeRuleEventResponse {
    return new AcknowledgeRuleEventResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AcknowledgeRuleEventResponse | PlainMessage<AcknowledgeRuleEventResponse> | undefined, b: AcknowledgeRuleEventResponse | PlainMessage<AcknowledgeRuleEventResponse> | undefined): boolean {
    return proto3.util.equals(AcknowledgeRuleEventResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.SuggestRuleRequest
 */
export class SuggestRuleRequest extends Message<SuggestRuleRequest> {
  /**
   * Plain-English, e.g. "mobile US/CA traffic excluding bots" (CLICK) or
   * "warn me if spend jumps 50% in an hour" (METRICS).
   *
   * @generated from field: string description = 1;
   */
  description = "";

  /**
   * domain hints which leaf family to draft. UNSPECIFIED lets the model pick.
   *
   * @generated from field: tracker.v1.RuleDomain domain = 2;
   */
  domain = RuleDomain.UNSPECIFIED;

  constructor(data?: PartialMessage<SuggestRuleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SuggestRuleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain", kind: "enum", T: proto3.getEnumType(RuleDomain) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuggestRuleRequest {
    return new SuggestRuleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuggestRuleRequest {
    return new SuggestRuleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuggestRuleRequest {
    return new SuggestRuleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SuggestRuleRequest | PlainMessage<SuggestRuleRequest> | undefined, b: SuggestRuleRequest | PlainMessage<SuggestRuleRequest> | undefined): boolean {
    return proto3.util.equals(SuggestRuleRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SuggestRuleResponse
 */
export class SuggestRuleResponse extends Message<SuggestRuleResponse> {
  /**
   * @generated from field: tracker.v1.Rule rule = 1;
   */
  rule?: Rule;

  /**
   * @generated from field: string rationale = 2;
   */
  rationale = "";

  /**
   * @generated from field: repeated tracker.v1.FieldError errors = 3;
   */
  errors: FieldError[] = [];

  constructor(data?: PartialMessage<SuggestRuleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SuggestRuleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rule", kind: "message", T: Rule },
    { no: 2, name: "rationale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "errors", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuggestRuleResponse {
    return new SuggestRuleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuggestRuleResponse {
    return new SuggestRuleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuggestRuleResponse {
    return new SuggestRuleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SuggestRuleResponse | PlainMessage<SuggestRuleResponse> | undefined, b: SuggestRuleResponse | PlainMessage<SuggestRuleResponse> | undefined): boolean {
    return proto3.util.equals(SuggestRuleResponse, a, b);
  }
}

